import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a063d45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bindwx" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "绑定用户", -1))
const _hoisted_3 = { class: "bindwx-phone" }

import { onMounted, reactive, ref } from 'vue';
import {
  JuouProTable,
  JuouProTableColumn,
  JuouProTableData,
  JuouProTableFilter,
  JuouProTableGetDataFunction,
  JuouDangerDialog,
  JuouProForm,
  JuouProFormItem,
  useBaseAsync,
  useRoute,
} from 'juou-managebase-ui';
import { ElForm, ElMessage } from 'element-plus';
import { useApi } from '@/hooks/useApi';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const countDown = ref(0);
const getCurrentUrl = () => {
  const { protocol, hostname, pathname } = window.location;
  return encodeURI(`${protocol}//${hostname}${pathname}`);
};

const loginCode = ref('');
const form = ref({
  phone: '',
  phoneCode: '',
});
const formRef = ref<InstanceType<typeof ElForm>>();

const rules = reactive<any>({
  phone: [
    { required: true, message: '请输入手机号' },
    // eslint-disable-next-line prefer-named-capture-group
    { regex: /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/u, message: '手机号格式错误' },
  ],
  phoneCode: [
    { required: true, message: '请输入验证码' },
    { regex: /^\d{6}$/u, message: '请输入6位数字验证码' },
  ],
});


const countDownStart = () => {
  countDown.value = 60;
  const timer = setInterval(() => {
    countDown.value--;
    if (countDown.value === 0) {
      clearInterval(timer);
    }
  }, 1000);
};


const sendSms = async() => {
  await formRef.value?.validate();

  try {
    await useApi().userwxApi.sendCodeuserwx({
      phone: Number(form.value.phone),
    });
    countDownStart();
    ElMessage.success('发送成功');
  } catch (error) {
    ElMessage.error('发送失败，请勿频繁发送');
  }
};

const handleBind = async() => {
  await formRef.value?.validate();

  try {
    await useApi().userwxApi.bindUseruserwx({
      phone: Number(form.value.phone),
      phoneCode: form.value.phoneCode,
      loginCode: loginCode.value,
    });
    ElMessage.success('绑定成功');
  } catch (error) {
    ElMessage.error('绑定失败');
  }
};

onMounted(() => {
  const { code, state = 'login' } = route.query;

  if (!code) {
    window.location.href
      = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdbbccd037d8d82c&redirect_uri=${
        getCurrentUrl()
      }&response_type=code&state=${state}&scope=snsapi_userinfo#wechat_redirect`;
    return;
  }

  loginCode.value = code as string;
});


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(ElForm), {
      model: form.value,
      ref_key: "formRef",
      ref: formRef,
      "label-width": "auto",
      rules: rules,
      style: {"max-width":"600px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "手机号" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_input, {
                modelValue: form.value.phone,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.phone) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: sendSms,
                disabled: countDown.value > 0
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(countDown.value > 0 ?
              `${countDown.value}秒后重新发送` : '发送验证码'), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "验证码" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: form.value.phoneCode,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.phoneCode) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              style: {"width":"100%"},
              onClick: handleBind
            }, {
              default: _withCtx(() => [
                _createTextVNode("绑定")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}
}

})